import { memo } from 'react'
import { themed, type IconProps } from '@tamagui/helpers-icon'
import { Svg, Path, SvgProps } from 'react-native-svg'
import { size as globalSize } from '../../theme/tokens'

const Icon = (propsBase: IconProps) => {
  const { color, size = globalSize.$7, ...otherProps } = propsBase as SvgProps & { size: number }

  return (
    <Svg width={size} height={size} fill={color} stroke={color} viewBox="0 0 32 32" {...otherProps}>
      <Path d="M4 29.1C3.7 29.1 3.5 29 3.3 28.8C2.9 28.4 2.9 27.8 3.3 27.4L12 18.8C12.4 18.4 13 18.4 13.4 18.8C13.8 19.2 13.8 19.8 13.4 20.2L4.7 28.8C4.6 29 4.3 29.1 4 29.1Z" />
      <Path d="M19 23C13.5 23 9 18.5 9 13C9 7.5 13.5 3 19 3C24.5 3 29 7.5 29 13C29 18.5 24.5 23 19 23ZM19 5C14.6 5 11 8.6 11 13C11 17.4 14.6 21 19 21C23.4 21 27 17.4 27 13C27 8.6 23.4 5 19 5Z" />
      <Path d="M23.9004 14.5001H23.8004C23.5004 14.4001 23.4004 14.2001 23.4004 13.9001C23.6004 12.7001 23.4004 11.5001 22.7004 10.5001C22.0004 9.5001 21.0004 8.8001 19.8004 8.6001C19.5004 8.5001 19.4004 8.3001 19.4004 8.0001C19.5004 7.7001 19.7004 7.6001 20.0004 7.6001C21.4004 7.9001 22.7004 8.7001 23.5004 10.0001C24.3004 11.2001 24.6004 12.7001 24.3004 14.1001C24.3004 14.3001 24.1004 14.5001 23.9004 14.5001Z" />
    </Svg>
  )
}

Icon.displayName = 'Search'

export const Search = memo<IconProps>(themed(Icon))
